/**
 * Helpers for partitioning space content into native vs merged-from-another-space buckets.
 */

export function partitionMerged<T>(items: T[], isMerged: (item: T) => boolean): { native: T[]; merged: T[] } {
    const native: T[] = [];
    const merged: T[] = [];
    for (const item of items) {
        (isMerged(item) ? merged : native).push(item);
    }
    return { native, merged };
}

export function isTopicMerged(topic: { mergedFromSpaceId?: string | null }): boolean {
    return !!(topic.mergedFromSpaceId != null && String(topic.mergedFromSpaceId).length > 0);
}

export function isThreadMerged(thread: { mergedFromSpaceId?: string | null }): boolean {
    return !!(thread.mergedFromSpaceId != null && String(thread.mergedFromSpaceId).length > 0);
}

export function isSourceMerged(source: { mergedFromSpaceId?: string | null }): boolean {
    return !!(source.mergedFromSpaceId != null && String(source.mergedFromSpaceId).length > 0);
}

export function isKnowledgeDocMerged(doc: { mergedFromSpaceId?: string | null; metadata?: unknown }): boolean {
    if (doc.mergedFromSpaceId != null && String(doc.mergedFromSpaceId).length > 0) return true;
    let meta = doc.metadata;
    if (typeof meta === "string") {
        try {
            meta = JSON.parse(meta) as Record<string, unknown>;
        } catch {
            return false;
        }
    }
    if (meta && typeof meta === "object" && "mergedFromSpaceId" in meta) {
        const v = (meta as { mergedFromSpaceId?: string }).mergedFromSpaceId;
        return v != null && String(v).length > 0;
    }
    return false;
}
